import { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';

// Import helpers
import { saveToLocalStorage, getFromLocalStorageOrPlaceholder, clearLocalStorage } from './helpers';

export const useFileUploader = ({ onSubmit, inProgress, config }) => {
	const [file, setFile] = useState(null);
	const [shadowName, setShadowName] = useState(config.placeholder);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const onDrop = useCallback((acceptedFiles) => {
		setFile(acceptedFiles[0]);
	}, []);

	useEffect(() => {
		if (inProgress) {
			setShadowName(getFromLocalStorageOrPlaceholder(config.placeholder));
		} else {
			clearLocalStorage();
			setShadowName(config.placeholder);
		}
		// eslint-disable-next-line
	}, [inProgress]);

	const clear = () => {
		setFile(null);
		setShadowName(config.placeholder);
	};

	const submit = async () => {
		setIsSubmitting(true);
		const formdata = new FormData();
		formdata.append('file', file, file.name);
		await onSubmit(formdata, clear);
		saveToLocalStorage(file.name);
		setIsSubmitting(false);
	};

	const { getRootProps, getInputProps, open } = useDropzone({
		maxFiles: config.maxFiles,
		accept: config.acceptedFiles,
		onDrop,
		disabled: inProgress
	});

	return {
		file,
		submit,
		shadowName,
		rootProps: getRootProps(),
		inputProps: getInputProps(),
		open,
		isSubmitting
	};
};
